import { c as _c } from "react/compiler-runtime";
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@xefi/x-react/tooltip';
import { useTranslation } from 'react-i18next';
import type { SurveyHome } from '@/models/survey';
type ShowPreviewProps = {
  survey: SurveyHome;
};
export const ShowPreview = t0 => {
  const $ = _c(11);
  const {
    survey
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("survey.actions.preview");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      content: "p-0 m-0"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== survey.id) {
    t3 = event => {
      event.stopPropagation();
      window.open(`/preview/survey?sId=${survey.id}`, "_blank");
    };
    $[3] = survey.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon size="lg" icon={faEye} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <button className="flex size-8 cursor-pointer items-center justify-center rounded-md transition-colors" onClick={t3}>{t4}</button>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <Tooltip content={t1} placement="top" size="sm" classNames={t2} trigger={t5} />;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};